/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
// import 'date-fns';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
import Loader from '../../Loader';
// import Typography from '@material-ui/core/Typography';
// import withStyles from '@material-ui/core/styles/withStyles';
// import MomentUtils from '@date-io/moment';
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
//   DatePicker,
// } from '@material-ui/pickers';
// import Slider from '@material-ui/core/Slider';
import useDebounce from '../../../utils/useDebounce';
import getAllPostRoles from '../../../api/graphql/queries/getAllPostRoles';

const UsersToolbar = (props) => {
  const {
    active,
    setActive,
    email,
    setEmail,
    name,
    setName,
    setSocialnetwork,
    setVerified,
    setRole,
    startDate,
    setStartDate,
    finishDate,
    setFinishDate,
    handleDownload,
    handleDownloadAll,
    downloadingInProgress,
    downloadingAllInProgress,
    // RDL-only props
    isRdl,
    hasAddress,
    setHasAddress,
    sendMagazine,
    duplicatesOnly,
    setDuplicatesOnly,
    setSendMagazine,
    handleDownloadMagazine,
    downloadingMagazineInProgress,
  } = props;

  // Initialize local state with values from shared filters (URL params)
  const [emailSearch, setEmailSearch] = useState(email || '');
  const [userRoles, setUserRoles] = useState([]);
  const debouncedEmail = useDebounce(emailSearch, 500);

  // Sync local state with URL params when they change (e.g., when switching tabs)
  useEffect(() => {
    setEmailSearch(email || '');
  }, [email]);

  useEffect(() => {
    setEmail(emailSearch || null);
  }, [debouncedEmail]);

  const [nameSearch, setNameSearch] = useState(name || '');
  const debouncedName = useDebounce(nameSearch, 500);

  // Sync local state with URL params when they change
  useEffect(() => {
    setNameSearch(name || '');
  }, [name]);

  useEffect(() => {
    setName(nameSearch || null);
  }, [debouncedName]);

  const [startDateSearch, setStartDateSearch] = useState(startDate || '');
  const debouncedStartDate = useDebounce(startDateSearch, 500);

  // Sync local state with URL params when they change
  useEffect(() => {
    setStartDateSearch(startDate || '');
  }, [startDate]);

  useEffect(() => {
    const date = new Date(new Date(startDateSearch).toDateString());
    if (startDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setStartDate(startDateSearch || null);
    }
  }, [debouncedStartDate]);

  const [finishDateSearch, setFinishDateSearch] = useState(finishDate || '');
  const debouncedFinalDate = useDebounce(finishDateSearch, 500);

  // Sync local state with URL params when they change
  useEffect(() => {
    setFinishDateSearch(finishDate || '');
  }, [finishDate]);

  useEffect(() => {
    const date = new Date(new Date(finishDateSearch).toDateString());
    if (finishDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setFinishDate(finishDateSearch || null);
    }
  }, [debouncedFinalDate]);

  useEffect(() => {
    getAllPostRoles('').then(roles => setUserRoles(roles.roles));
  }, []);

  // const handleChangeRange = (event, newValue) => {
  //   rangeSetValue(newValue);
  // };
  // const setRangeFilter = (event, newValue) => {
  //   setPriceFilter(newValue);
  // };

  return (
    <div className="flex flex-wrap">
      <div className="flex w-1/6 my-6 items-center">
        <label htmlFor="toggle" className="block uppercase tracking-wide text-gray-700 text-xs font-bold mr-2">Active</label>
        <div className="relative inline-block w-10 mr-2 align-middle select-none transition duration-200 ease-in">
          <input
            type="checkbox"
            name="toggle"
            id="toggle"
            value={active}
            onChange={() => setActive(!active)}
            checked={active}
            className="outline-none toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-4 appearance-none cursor-pointer"
          />
          <label htmlFor="toggle" className="toggle-label block overflow-hidden h-6 rounded-full bg-grey cursor-pointer" />
        </div>
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="emailSearch"
        >
          Email
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="emailSearch"
          type="text"
          onChange={e => setEmailSearch(e.target.value)}
          value={emailSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="nameSearch"
        >
          Name
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="nameSearch"
          type="text"
          onChange={e => setNameSearch(e.target.value)}
          value={nameSearch}
        />
      </div>

      <div className="px-3 md:mb-0">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 whitespace-nowrap" htmlFor="grid-state">
          Social Login
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={e => setSocialnetwork(e.currentTarget.value)}
          >
            <option value="" />
            <option value="userpass">User/Password</option>
            <option value="facebook">Facebook</option>
            <option value="google">Google</option>
            <option value="spotify">Spotify</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="px-3 md:mb-0">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Verified
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={e => setVerified(e.currentTarget.value)}
          >
            <option value="" />
            <option value="true">Yes</option>
            <option value="false">No</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="px-3 md:mb-0">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Role
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={e => setRole(e.currentTarget.value)}
          >
            <option value="" />
            {userRoles && userRoles.map(userRole => <option key={userRole} value={userRole}>{userRole}</option>)}
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      {/* RDL-only filters */}
      {isRdl && (
        <>
          <div className="px-3 md:mb-0">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="hasAddressFilter">
              Address
            </label>
            <div className="relative">
              <select
                id="hasAddressFilter"
                className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                value={hasAddress === null ? '' : hasAddress}
                onChange={e => setHasAddress(e.currentTarget.value === '' ? null : e.currentTarget.value)}
              >
                <option value="" />
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div>

          <div className="px-3 md:mb-0">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="sendMagazineFilter">
              Send Magazine?
            </label>
            <div className="relative">
              <select
                id="sendMagazineFilter"
                className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                value={sendMagazine === null ? '' : sendMagazine}
                onChange={e => setSendMagazine(e.currentTarget.value === '' ? null : e.currentTarget.value)}
              >
                <option value="" />
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div>

          <div className="px-3 md:mb-0">
            <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="duplicatesOnlyFilter">
              Duplicates?
            </label>
            <div className="relative">
              <select
                id="duplicatesOnlyFilter"
                className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                value={duplicatesOnly === null ? '' : duplicatesOnly}
                onChange={e => setDuplicatesOnly(e.currentTarget.value === '' ? null : e.currentTarget.value)}
                title="Only accounts whose subscription sits on another account"
              >
                <option value="" />
                <option value="yes">Only duplicates</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
                <svg
                  className="fill-current h-4 w-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                >
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
                </svg>
              </div>
            </div>
          </div>
        </>
      )}

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="startDateSearch"
        >
          Start Date (yyyy-mm-dd)
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="startDateSearch"
          type="text"
          onChange={e => setStartDateSearch(e.target.value)}
          value={startDateSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="finishDateSearch"
        >
          Final Date (yyyy-mm-dd)
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="finishDateSearch"
          type="text"
          onChange={e => setFinishDateSearch(e.target.value)}
          value={finishDateSearch}
        />
      </div>

      <div className="px-3 md:mb-0">
        <div className="mb-2">
          &nbsp;
        </div>
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={handleDownload}>
          {!downloadingInProgress && 'Download filtered'}
          {downloadingInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
        </button>
      </div>

      <div className="px-3 md:mb-0">
        <div className="mb-2">
          &nbsp;
        </div>
        <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="download" onClick={handleDownloadAll}>
          {!downloadingAllInProgress && 'Download all'}
          {downloadingAllInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
        </button>
      </div>

      {/* RDL-only: Download Magazine Recipients button */}
      {isRdl && (
        <div className="px-3 md:mb-0">
          <div className="mb-2">
            &nbsp;
          </div>
          <button className="font-americaMonoBold text-xs px-3 py-1 rounded-full uppercase bg-greyFilter" type="button" id="downloadMagazine" onClick={handleDownloadMagazine}>
            {!downloadingMagazineInProgress && 'Magazine CSV'}
            {downloadingMagazineInProgress && <Loader type="TailSpin" color="#000" height="20" width="20" />}
          </button>
        </div>
      )}

      {/* <Grid
        className={classes.range}
        item
        lg={3}
        sm={6}
        xl={3}
        xs={12}
        m={2}
      >
        <Typography id="range-slider">
          Order price range
        </Typography>
        <Slider
          value={rangeValue}
          onChange={handleChangeRange}
          onChangeCommitted={setRangeFilter}
          aria-labelledby="range-slider"
          valueLabelDisplay="auto"
          min={0}
          max={2000}
        />
      </Grid> */}
    </div>
  );
};

UsersToolbar.propTypes = {
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired,
  email: PropTypes.string,
  setEmail: PropTypes.func.isRequired,
  name: PropTypes.string,
  setName: PropTypes.func.isRequired,
  setSocialnetwork: PropTypes.func.isRequired,
  setVerified: PropTypes.func.isRequired,
  setRole: PropTypes.func.isRequired,
  startDate: PropTypes.string,
  setStartDate: PropTypes.func.isRequired,
  finishDate: PropTypes.string,
  setFinishDate: PropTypes.func.isRequired,
  handleDownload: PropTypes.func.isRequired,
  handleDownloadAll: PropTypes.func.isRequired,
  downloadingInProgress: PropTypes.bool.isRequired,
  downloadingAllInProgress: PropTypes.bool.isRequired,
  // RDL-only props
  isRdl: PropTypes.bool,
  hasAddress: PropTypes.string,
  setHasAddress: PropTypes.func,
  sendMagazine: PropTypes.string,
  duplicatesOnly: PropTypes.string,
  setDuplicatesOnly: PropTypes.func,
  setSendMagazine: PropTypes.func,
  handleDownloadMagazine: PropTypes.func,
  downloadingMagazineInProgress: PropTypes.bool,
};

UsersToolbar.defaultProps = {
  email: null,
  name: null,
  startDate: null,
  finishDate: null,
  isRdl: false,
  hasAddress: null,
  setHasAddress: () => { },
  sendMagazine: null,
  duplicatesOnly: null,
  setDuplicatesOnly: () => {},
  setSendMagazine: () => { },
  handleDownloadMagazine: () => { },
  downloadingMagazineInProgress: false,
};

export default UsersToolbar;
